import * as productionsActions from './actions';
import productionsEpics from './epics';
import reducer from './reducers';
import * as productionsSelectors from './selectors';
import * as productionsTypes from './types';

export { productionsActions, productionsEpics, productionsSelectors, productionsTypes };

export default reducer;
